

//import axios from "axios";
import ApiService from "@/core/services/api.service";
// action types
export const OBTENER_TIPOS_EMPRESA = "obtenerTiposEmpresa";
export const OBTENER_TIPO_EMPRESA = "obtenerTipoEmpresa";
export const REGISTRAR_TIPO_EMPRESA = "registrarTipoEmpresa";
export const ACTUALIZAR_TIPO_EMPRESA = "actualizarTipoEmpresa";
// mutation types
export const SET_TIPOS_EMPRESA = "setEtnias";
export const SET_TIPO_EMPRESA = "setEtnia";

const state = {
    tiposEmpresa: [],
    tipoEmpresa:[],
}

const getters = {
    obtenerTiposEmpresa(state) {
      return state.tiposEmpresa;
    },
}

const actions = {
    async [OBTENER_TIPOS_EMPRESA](context, estadoId) {

        /*
        * Si el estado es null va a traer a todas las etnias, de lo contrario va a traer los etnias por estado
        *
        */
        let endpoint = 'api/Tipo_Empresa'
        if(estadoId){
            endpoint = `api/Tipo_Empresa/GetTipoEmpresasActivos/${estadoId}`
        }

        return new Promise(resolve => {
            ApiService.query(`apiconsume/obtener?endpoint=${endpoint}`, '')
                .then(({ data }) => {
                    context.commit(SET_TIPOS_EMPRESA, data.data);
                    //console.log(data)
                    resolve(data)
                })
                .catch((error) => {
                    console.log(error)

                    //context.commit(SET_ERROR, response.data.errors);
                });
        });       
    },
    async [OBTENER_TIPO_EMPRESA](context, id){
        
        return new Promise(resolve => {
            ApiService.query(`apiconsume/edit/${id}?endpoint=api/Tipo_Empresa/`)
                .then(({ data }) => {
                    context.commit(SET_TIPO_EMPRESA, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    console.log(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });    
    },
    async [REGISTRAR_TIPO_EMPRESA](context, datosTipoEmpresa){
        return new Promise(resolve => {
            ApiService.post(`apiconsume/create?endpoint=api/Tipo_Empresa`, datosTipoEmpresa)
                .then(({ data }) => {
                    context.commit(SET_TIPO_EMPRESA, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    console.log(error)
                });
        });   
    },
    async [ACTUALIZAR_TIPO_EMPRESA](context, datosTipoEmpresa){
        let id = datosTipoEmpresa.id;
        
        return new Promise(resolve => {
            ApiService.post(`apiconsume/update/${id}?endpoint=api/Tipo_Empresa/UpdateTipoEmpresa/`, datosTipoEmpresa)
                .then(({ data }) => {
                    context.commit(SET_TIPO_EMPRESA, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    console.log(error)
                });
        });    
    }
  }

const mutations = {
    [SET_TIPOS_EMPRESA](state, data) {
        state.tiposEmpresas = data;
    },

    [SET_TIPO_EMPRESA](state, data) {
        state.tipoEmpresa = data;
    }
}


export default {
    state,
    getters,
    actions,
    mutations
}